exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sc-comparison-table[data-v-2ebff9cf]{-webkit-box-orient:horizontal;-ms-flex-direction:row;flex-direction:row}.sc-comparison-table[data-v-2ebff9cf],.sc-comparison-table .row-header[data-v-2ebff9cf]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-direction:normal}.sc-comparison-table .row-header[data-v-2ebff9cf]{-webkit-box-orient:vertical;-ms-flex-direction:column;flex-direction:column;margin-top:auto}", ""]);

// exports
